// Vocabulary mirrors LibraryItemView's proto comment (item_type, status) —
// proto/mono/projectdata/v1/projectdata.proto.
export const ITEM_TYPES = [
    {
        value: 'evidence',
        label: 'Evidence'
    },
    {
        value: 'template',
        label: 'Template'
    },
    {
        value: 'proof_point',
        label: 'Proof point'
    },
    {
        value: 'narrative',
        label: 'Narrative'
    },
    {
        value: 'reference',
        label: 'Reference'
    }
];
// Statuses only shown for the My items scope filter — Discover results are
// always released (see libraryItemDenialReason), so a status filter would be
// decorative there.
export const STATUSES = [
    {
        value: 'draft',
        label: 'Draft'
    },
    {
        value: 'released',
        label: 'Released'
    },
    {
        value: 'withdrawn',
        label: 'Withdrawn'
    }
];
export function labelOf(options, value) {
    return options.find((o)=>o.value === value)?.label ?? value ?? '—';
}
// proto Timestamp -> short local date string, tolerant of an unset/invalid ts.
export function formatTs(ts) {
    if (!ts) return '—';
    try {
        return ts.toDate().toLocaleDateString();
    } catch  {
        return '—';
    }
}
export function parseDateInput(value) {
    if (!value) return null;
    const [y, m, d] = value.split('-').map(Number);
    if (!y || !m || !d) return null;
    return new Date(y, m - 1, d);
}
